import Marquee from "react-fast-marquee";
import { Reveal, SectionLabel } from "./ui";

export default function Partners({ partners = [], index, appr }) {
  return (
    <section style={appr?.style} className={`py-16 lg:py-20 text-white overflow-hidden ${appr?.dark ? "mf-section-dark" : ""}`}>
      <div className="mf-container">
        <Reveal>
          <SectionLabel index={index}>
            <span className="text-white/60">Hersteller & Software-Partner</span>
          </SectionLabel>
        </Reveal>
        <Reveal delay={0.05}>
          <p className="mt-5 max-w-2xl text-[1em] text-white/70 leading-relaxed">
            Wir arbeiten herstellerübergreifend und sind zertifizierter Partner mehrerer Marken.
          </p>
        </Reveal>
      </div>

      <div className="mt-12 mf-fade-x">
        <Marquee speed={38} gradient={false} pauseOnHover autoFill>
          {partners.map((p, i) => {
            const item = typeof p === "string" ? { name: p, logo: "" } : { name: p?.name || "", logo: p?.logo || "" };
            const chip = appr?.dark ? "bg-white/[0.06] border border-white/10" : "bg-white border border-black/5";
            return item.logo ? (
              <span key={i} className={`mx-6 inline-flex items-center ${chip} rounded-md px-5 py-3 align-middle`}>
                <img
                  data-testid={`partner-${i}`}
                  src={item.logo}
                  alt={item.name || `Partner ${i + 1}`}
                  className="h-8 lg:h-9 w-auto object-contain"
                />
              </span>
            ) : (
              <span
                key={i}
                data-testid={`partner-${i}`}
                className="mx-8 font-head font-semibold text-[1.25em] lg:text-[1.5em] text-white/45 hover:text-[var(--mf-red)] transition-colors duration-300 whitespace-nowrap"
              >
                {item.name}
              </span>
            );
          })}
        </Marquee>
      </div>
    </section>
  );
}
